import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
export function FinalCTA() {
  const handleCtaClick = () => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout');
    }
  };
  return <section className="py-20 lg:py-32 bg-[#E8441A] text-white text-center px-4" data-id="element-25">
      <div className="mx-auto max-w-4xl" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-27">
          <h2 className="text-4xl sm:text-5xl font-extrabold mb-6 leading-tight" data-id="element-28">
            Ready To Finally Burn That Stubborn Fat?
          </h2>
          <p className="text-xl sm:text-2xl mb-10 text-white/90 font-medium max-w-2xl mx-auto" data-id="element-29">
            Join thousands of women over 40 who have already transformed their
            bodies with CitrusBurn™
          </p>

          <div className="flex flex-col items-center gap-4" data-id="element-30">
            <a href="https://40dec9flnm4htzxbxn-n174kzw.hop.clickbank.net" onClick={handleCtaClick} className="inline-flex items-center justify-center px-8 py-5 text-xl font-extrabold text-[#E8441A] transition-all duration-200 bg-white rounded-full hover:bg-slate-50 hover:scale-105 shadow-2xl w-full sm:w-auto" data-id="element-31">
              WATCH THE FREE VIDEO NOW →
            </a>
            <div className="flex items-center justify-center gap-2 text-sm text-white/80 font-medium mt-4 flex-wrap" data-id="element-32">
              <Lock size={16} data-id="element-33" />
              <span data-id="element-34">
                100% Secure | 60-Day Money Back Guarantee | Free Shipping
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}